export default function Navigation(theme) {
  return {
    MuiListItem: {
      styleOverrides: {
        root: {
          // Navigation-specific ListItem styles - override all defaults
          '&[data-navigation="true"]': {
            margin: `${theme.spacing(0.5, 1)} !important`, // Margin around items when expanded
            padding: `${theme.spacing(1, 2)} !important`, // Padding inside items when expanded
            minHeight: 40,
            borderRadius: `${theme.shape.borderRadius}px !important`,
            justifyContent: 'flex-start !important',
            display: 'flex !important',
            alignItems: 'center !important',
            position: 'relative',
            boxSizing: 'border-box',
            width: '100%',
            textAlign: 'left',
            border: '0',
            outline: '0',
            cursor: 'pointer',
            userSelect: 'none',
            backgroundColor: 'transparent',
            transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            
            // Collapsed state - reduced margin and padding, centered content
            '&[data-collapsed="true"]': {
              margin: `${theme.spacing(0.5, 0.5)} !important`, // Margin when collapsed
              padding: `${theme.spacing(1)} !important`, // Padding for collapsed state
              justifyContent: 'center !important', // Center content when collapsed
              
              // Center the icon when collapsed
              '& .MuiListItemIcon-root': {
                minWidth: '0 !important',
                width: '100% !important',
                marginRight: '0 !important',
                marginLeft: '0 !important',
                justifyContent: 'center !important',
                display: 'flex !important',
                alignItems: 'center !important',
                margin: '0 auto !important',
              },
            },
            
            // Active state
            '&[data-active="true"]': {
              background: 'radial-gradient(circle, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 1) 36%, rgba(255, 255, 255, 0) 80%)',
              color: `${theme.palette.common.white} !important`,
              fontWeight: 'bold !important',
              '& .MuiListItemIcon-root': {
                color: `${theme.palette.common.white} !important`,
              },
            },
            
            // Hover state
            '&:hover': {
              backgroundColor: `${theme.palette.action.hover} !important`,
            },
            
            // Child navigation items
            '&[data-navigation-child="true"]': {
              paddingLeft: `${theme.spacing(4)} !important`,
              paddingTop: `${theme.spacing(0.75)} !important`,
              paddingBottom: `${theme.spacing(0.75)} !important`,
              margin: '0 !important', // No margin for child items
              '&[data-collapsed="true"]': {
                paddingLeft: `${theme.spacing(1)} !important`,
                paddingRight: `${theme.spacing(1)} !important`,
                justifyContent: 'center !important',
              },
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          // Navigation-specific ListItemIcon styles
          '&[data-navigation="true"]': {
            minWidth: '0 !important', // Remove minWidth completely
            marginRight: `${theme.spacing(2)} !important`,
            color: `${theme.palette.text.secondary} !important`,
            display: 'flex !important',
            alignItems: 'center !important',
            justifyContent: 'flex-start !important',
            
            // Collapsed state - icon centering is handled by parent ListItem override
            '&[data-collapsed="true"]': {
              minWidth: '0 !important',
              marginRight: '0 !important',
              marginLeft: '0 !important',
            },
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          margin: '0 !important',
          padding: '0 !important',
        },
        primary: {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          '&[data-collapsed="true"]': {
            display: 'none', // Hide text when collapsed
          },
        },
      },
    },
  };
}

